



// 



export type PermissionNames =
    "View Users" | "Manage Users" |
    "View Roles" | "Manage Roles" | "Assign Roles";

export type PermissionValues =
    "users.view" | "users.manage" |
    "roles.view" | "roles.manage" | "roles.assign" |
    "groups.read" | "groups.write" |
    "plans.read" | "plans.write" |
    "benefits.read" | "benefits.write" |
    "vendors.read" | "vendors.write" |
    "members.read" | "members.write" |
    "efulfillment.manage"
    ;

export class Permission {

    public static readonly viewUsersPermission: PermissionValues = "users.view";
    public static readonly manageUsersPermission: PermissionValues = "users.manage";

    public static readonly viewRolesPermission: PermissionValues = "roles.view";
    public static readonly manageRolesPermission: PermissionValues = "roles.manage";
    public static readonly assignRolesPermission: PermissionValues = "roles.assign";

    public static readonly readGroupsPermission: PermissionValues = "groups.read";
    public static readonly writeGroupsPermission: PermissionValues = "groups.write";

    public static readonly readPlansPermission: PermissionValues = "plans.read";
    public static readonly writePlansPermission: PermissionValues = "plans.write";

    public static readonly readBenefitsPermission: PermissionValues = "benefits.read";
    public static readonly writeBenefitsPermission: PermissionValues = "benefits.write";

    public static readonly readVendorsPermission: PermissionValues = "vendors.read";
    public static readonly writeVendorsPermission: PermissionValues = "vendors.write";

    public static readonly readMembersPermission: PermissionValues = "members.read";
    public static readonly writeMembersPermission: PermissionValues = "members.write";

    public static readonly manageefulfillmentPermission: PermissionValues = "efulfillment.manage";


    constructor(name?: PermissionNames, value?: PermissionValues, groupName?: string, description?: string) {
        this.name = name;
        this.value = value;
        this.groupName = groupName;
        this.description = description;
    }

    public name: PermissionNames;
    public value: PermissionValues;
    public groupName: string;
    public description: string;
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/models/permission.model.ts